import React, {useEffect, useState} from "react";
import {apiFetch} from "../../utils/api";
import {BASE_URLS} from "../../config/urls";
import { ModalShell } from "./ModalShell";
import {BtnSpinner} from "../fields/BtnSpinner";

export function ChangePasswordModal({
                                 isOpen,
                                 onClose,
                             }: {
    isOpen: boolean;
    onClose: () => void;
}) {
    const [oldPass, setOldPass] = useState("");
    const [newPass, setNewPass] = useState("");
    const [newPass2, setNewPass2] = useState("");
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState("");
    const [ok, setOk] = useState("");

    useEffect(() => {
        if (isOpen) {
            setOldPass("");
            setNewPass("");
            setNewPass2("");
            setErr("");
            setOk("");
            setSaving(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const save = async () => {
        setErr("");
        setOk("");
        setSaving(true);

        try {
            if (!oldPass.trim()) throw new Error("Введите текущий пароль");
            if (!newPass.trim()) throw new Error("Введите новый пароль");
            if (newPass.trim().length < 6) throw new Error("Пароль должен быть минимум 6 символов");
            if (newPass !== newPass2) throw new Error("Пароли не совпадают");

            const resp = await apiFetch(`${BASE_URLS.api}/change_password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ old: oldPass, newPassword: newPass }),
            });

            if (!resp.ok) {
                const msg = await resp.text().catch(() => "");
                setErr(msg || "Ошибка изменения пароля");
                return;
            }

            setOk("Пароль обновлён");
            setOldPass("");
            setNewPass("");
            setNewPass2("");

            setTimeout(onClose, 600);
        } catch (e: any) {
            setErr(e?.message || "Ошибка");
        } finally {
            setSaving(false);
        }
    };

    return (
        <ModalShell title="Изменение пароля" subtitle="Введите текущий и новый пароль" onClose={onClose}>
            {err && <div className="profile-error">{err}</div>}
            {ok && <div className="profile-success">{ok}</div>}

            <div className="profile-modal-grid profile-modal-grid--one">
                <div className="profile-field">
                    <label className="profile-label">Текущий пароль</label>
                    <input
                        className="profile-input"
                        type="password"
                        value={oldPass}
                        onChange={(e) => setOldPass(e.target.value)}
                    />
                </div>

                <div className="profile-field">
                    <label className="profile-label">Новый пароль</label>
                    <input
                        className="profile-input"
                        type="password"
                        value={newPass}
                        onChange={(e) => setNewPass(e.target.value)}
                    />
                </div>

                <div className="profile-field">
                    <label className="profile-label">Повтор нового пароля</label>
                    <input
                        className="profile-input"
                        type="password"
                        value={newPass2}
                        onChange={(e) => setNewPass2(e.target.value)}
                    />
                </div>
            </div>

            <div className="profile-modal-actions">
                <button className="profile-secondary-btn" onClick={onClose} disabled={saving}>
                    Отмена
                </button>
                <button className="profile-primary-btn" onClick={save} disabled={saving}>
                    {saving ? <BtnSpinner/> : "Сохранить"}
                </button>
            </div>
        </ModalShell>
    );
}